let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("9n0AM")).then(() => parcelRequire('12tqw'));